export const createDealTimelineData = (activeUser: any, action: string, type: string, details: string, message?: string) => {
  return {
    dataset: 'deals',
    user: {
      id: activeUser?.user?.id || activeUser?.id || '',
      name: activeUser?.real_name || activeUser?.name,
      image: activeUser?.user?.profile?.image_512 || activeUser?.image_512,
    },
    action: action,
    type: type,
    details: details,
    message: message,
  }
}

export const updateDealTimelineData = (id: string, activeUser: any, action: string, type: string, details: string, message?: string) => {
  return {
    id: id,
    timeline_uuid: id,
    dataset: 'deals',
    user: {
      id: activeUser?.user?.id || activeUser?.id || '',
      name: activeUser?.real_name || activeUser?.name,
      image: activeUser?.profile?.image_512 || activeUser?.user?.profile?.image_512,
    },
    action: action,
    type: type,
    details: details,
    message: message,
  }
}
export const updateContractTimelineData = (id: string, activeUser: any, action: string, type: string, details: string, message?: string) => {
  return {
    id: id,
    timeline_uuid: id,
    dataset: 'deals',
    user: {
      id: activeUser?.user?.id || activeUser?.id || '',
      name:
        activeUser?.real_name ||
        activeUser?.user?.real_name ||
        activeUser?.user?.profile?.real_name ||
        activeUser?.name,
      image: activeUser?.profile?.image_512 || activeUser?.user?.profile?.image_512,
    },
    action: action,
    type: type,
    details: details,
    message: message,
  }
}
